import React from 'react';
import NavBar from '../components/NavBar';
import './BookPage.css';
import API from '../API';
import Colors from '../Colors';
import MoneyIcon from '../assets/money.png';
import CardIcon from '../assets/card.png';
import Cards from 'react-credit-cards';
import 'react-credit-cards/es/styles-compiled.css';
import { PaymentInputsWrapper, usePaymentInputs } from 'react-payment-inputs';
import CreditCardInput from 'react-credit-card-input';
var latestFocus;
var focused = false;
const rnd = (len, chars='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789') => [...Array(len)].map(() => chars.charAt(Math.floor(Math.random() * chars.length))).join('')
var session = rnd(36);


const pricings =[
    {
        name: "Motorsiklet",
        image: require("../assets/vehicles/Motor.png"),
        sizeLimit: "35 x 25 x 12 cm",
        weight: 5
    },{
        name: "Sedan",
        image: require("../assets/vehicles/araclar-16.svg").default,
        sizeLimit:"70 x 50 x 50 cm",
        weight: 500
    },{
        name: "Doblo",
        image: require("../assets/vehicles/Doblo.png"),
        sizeLimit:"1.8 x 1.5 x 1.2 m",
        weight: 500
    },{
        name: "Minivan",
        image: require("../assets/vehicles/araclar-14.svg").default,
        sizeLimit:"2.1 x 1.7 x 1.2 m",
        weight: 1000
    },{
        name: "Panelvan",
        image: require("../assets/vehicles/Panelvan.png"),
        sizeLimit:"3 x 1.5 x 1.5 m",
        weight: 2500
    },{
        name: "Kamyonet",
        image: require("../assets/vehicles/Kamyonet.png"),
        sizeLimit:"4.2 x 2 x 2 m",
        weight: 2500
    }
]

const helper_cost = [0,0,150,150,150,200];

export default class BookPage extends React.Component {

    constructor() {
        super();
        
        this.state = {waypoints: [{Label: ""}, {Label: ""}], calculations: undefined,paymentState: 0, paymentProcessing: false,additionals: [false,false,false,false,0], date: 0,cardErrorEmpty: false,cardPaymentPrompt: false,cvc: '',
        expiry: '',
        focus: '',
        name: '',
        number: ''};

       
    }

    componentDidMount() {
        this.eventHandler = (e) => this.onEvent(e);
        window.addEventListener('message', this.eventHandler);
    }

    onEvent(event) {

        console.log(event.origin);
        if(this.state.UCD_URL && (event.origin.includes(API.SERVER_URL) || API.SERVER_URL.includes(event.origin))) {
            const data = JSON.parse(event.data);
            if(data.error) {
                this.setState({paymentState:2, UCD_URL: undefined, paymentErrorMsg: data.str});
            } else {
                
            }
        }
    }

    componentWillUnmount() {
        window.removeEventListener('message', this.eventHandler);
    }

    checkCalculation() {
        var foundNull = this.state.waypoints.find((s) => s.Point == undefined);
        
        if(foundNull) {
            if(this.state.calculations != undefined)
                this.setState({calculations: undefined});
        } else {

            
            (API.user?API.fetchClient:API.fetch)("calculate",{waypoints: this.state.waypoints, date: this.state.date}).then((e) => {
                if(!e.routes) {
                    e.routes = e.map((x) => ({price: x,time: 0,traffic: false, waypointFee: 0, bridges: []}));
                }
                console.log(e);
                this.setState({calculations: e.routes});
            })
        }
    }
    render() {
        return <div style={{paddingTop:0,display:"flex",flex:1}}>
            <NavBar />
            <div className='bookingRoot'>
            <div className='bookingMain'>
                <div className='bookingDetails'>
                <p style={{fontSize:25, color:"#242a2e", fontWeight:"500"}}>Gönderi</p>

                <p style={{fontSize:20, color:"#9fa4ad", fontWeight:"600", marginTop:30}}>Rota</p>

                {this.state.waypoints.map((x, i) => <Waypoint removeWaypoint={() => {
                    this.state.waypoints.splice(i, 1);
                    this.forceUpdate();
                }} canClose={(i >= 2)} waypoint={x} onSelectedWaypoint={(way) => {
                    x.Label = way.Label;
                    
                    this.forceUpdate();
     
                    API.fetchClient("autocompleteendsession", {session, _id: way.place}).then((waypoint) => {
                        //waypoint.Label = way.Label;
                        //way.Point = waypoint.Point;

                        this.state.waypoints[i].Point = waypoint.Point;
                        
                        //console.log(waypoint);
                         //this.state.waypoints[i] = waypoint;
                         
         
         
                         if(waypoint) {
                            
                             console.log(waypoint);
                             this.checkCalculation();
                             
                         }
                     });
                }} key={i} id={i} placeholder={i == 0?"Gönderi adresi ara":"Teslim adresi ara"} />)}


                <p onClick={() => {
                    this.state.waypoints.push([{Label :""}]);
                    this.forceUpdate();
                }} style={{cursor:"pointer", color:Colors.Blue, marginTop:20}}>Rota noktası ekle</p>


<p style={{fontSize:20, color:"#9fa4ad", fontWeight:"600", marginTop:30}}>Araç tipi</p>

                <div style={{gap:20,width:"100%",display:"flex",marginTop:20,flexWrap:"wrap"}}>
                {pricings.map((x, i) => {
                    if(i == 1 || i == 3) return <div key={i}></div>

                    return <div key={i} onClick={() => {
                        this.setState({vehicle: i, additionals: [false,false,false,false,0]});
                    }} className={'bookVehicleRoot'+(i == this.state.vehicle?" bookSelected":"")}>
                        <div className='bookVehicleImage'>
                            <img src={x.image} />

                            
                        </div>
                        <p className='vehicleName'>{x.name}</p>
                        {this.state.calculations != undefined && <p className='vehiclePricing'>{this.state.calculations[i].price}₺</p>}

                        <div className='vehicleDescriptions'>
                        <p>{x.sizeLimit}</p>
                        <p>{x.weight}kg</p>
                        </div>
                    </div>
                })}
                </div>

                {this.state.vehicle != undefined && this.state.vehicle >= 2 && <>
                    <p style={{fontSize:20, color:"#9fa4ad", fontWeight:"600", marginTop:30}}>Ek servisler</p>
                    {this.state.vehicle >= 2 && <CheckboxService value={this.state.additionals[0]} onChange={(e) => {this.state.additionals[0] = e; this.forceUpdate()}} title={"Ön koltukta refakatçi"} />}
                    {this.state.vehicle == 2 && <CheckboxService value={this.state.additionals[1]} onChange={(e) => {this.state.additionals[1] = e; this.forceUpdate()}} title={"Evcil hayvanım ile seyahat"} />}
                    {this.state.vehicle == 5 && <CheckboxService value={this.state.additionals[2]} onChange={(e) => {this.state.additionals[2] = e; this.forceUpdate()}} title={"Üstü kapalı kamyonet"} />}
                    
                    <div style={{display:"flex",flex:1, justifyContent:"space-between", maxWidth:530,alignItems:"center"}}>
                    <div style={{width:"fit-content", marginBottom:10}}>
                        <div className='helper'>
                        <button onClick={() => {this.state.additionals[4] = Math.max(this.state.additionals[4]-1,0);this.forceUpdate()}}>-</button>
                        <p className='helperText'>{this.state.additionals[4]}</p>
                        <button onClick={() => {this.state.additionals[4] = Math.min(this.state.additionals[4]+1,6);this.forceUpdate()}}>+</button>

                        <p style={{marginLeft:10,fontSize:18}}>Kapıdan kapıya yardımcı</p>
                        </div>
                        {this.state.additionals[4] > 0 && <p className='driverAlt' style={{position:"absolute"}}>Sürücünün yardımı {this.state.additionals[4] > 1?" ve "+(this.state.additionals[4]-1)+" yardımcı":""}</p>}
                    </div>
                    {this.state.additionals[4] > 0 && <p className='additionalServicePricing'>{(this.state.vehicle == 2?.5:1)*helper_cost[this.state.vehicle]+(Math.max(this.state.additionals[4]-1,0)*helper_cost[this.state.vehicle])}₺</p>}
                    </div>
                </>}


                    <p style={{fontSize:20, color:"#9fa4ad", fontWeight:"600", marginTop:30}}>Ödeme yöntemi</p>


                    <div style={{display:"flex", flex:1,maxWidth:530, gap:20,marginTop:20}}>
                        <PaymentMethod onClick={() => this.setState({paymentMethod:0})} selected={this.state.paymentMethod == 0} src={CardIcon} title={"Online Ödeme"} />
                        <PaymentMethod onClick={() => this.setState({paymentMethod:1})} selected={this.state.paymentMethod == 1} src={MoneyIcon} title={"Nakit Ödeme"} />
                    </div>
                </div>

                <div className='pricingDetails'>
                <p style={{fontSize:20, color:"#242a2e", fontWeight:"500",marginBottom:32}}>Fiyatlandırma</p>

                
                {this.state.calculations != undefined && this.state.vehicle != undefined && <>
                
                    <Pricing title={"Baz Fiyat"} value={this.state.calculations[this.state.vehicle].price} />
                
                    </>}

                    {this.state.vehicle != undefined && this.state.additionals[4] > 0 && <Pricing title={"Kapıdan kapıya yardımcı x" + this.state.additionals[4]} value={(this.state.vehicle == 2?.5:1)*helper_cost[this.state.vehicle]+(Math.max(this.state.additionals[4]-1,0)*helper_cost[this.state.vehicle])} />}
                
                <div className='pricingFinalRoot' style={{display:"flex", flex:1, justifyContent:"space-between"}}>
        <p>Toplam Tutar</p>
        <p>{this.calculatePricing().toFixed(2)
            
                
            }₺</p>

       
    </div>
    {(this.state.calculations == undefined && <p style={{color:"crimson", fontSize:14}}>Lütfen sipariş vermek için adresleri giriniz</p>) || 
    (this.state.vehicle == undefined && <p style={{color:"crimson", fontSize:14}}>Lütfen araç seçimi yapınız</p>) || (this.state.paymentMethod == undefined && <p style={{color:"crimson", fontSize:14}}>Lütfen ödeme seçimi yapınız</p>)}
{/* disabled={this.state.calculations == undefined || this.state.vehicle == undefined}  */}
                <button onClick={() => {
                    if(!API.user) {
                    global.promptLogin(() => {
                        this.checkCalculation();
                    });
                } else {
                    if(this.state.paymentMethod != 1) {
                        this.setState({cvc: '',
                        expiry: '',
                        focus: '',
                        name: '',
                        number: '',cardPaymentPrompt: true,paymentState: 0});
                    } else {
                        this.setState({bookingLoading: true});
                        this.book();
                    }
                }
                }} disabled={this.state.calculations == undefined || this.state.vehicle == undefined || this.state.paymentMethod == undefined} className='bookButton'>Siparişi Oluştur</button>
                </div>
            </div>
            </div>

            <div className={'bookingLoadingPanel'+(this.state.bookingLoading?" enabled":"")}>
            <div className="loading-spinner-big">
      
      </div>
            </div>

            <div className={'bookingCardPayment'+(this.state.cardPaymentPrompt?" enabled":"")}>

            
                <div className='bookingCardPaymentRoot'>
                    
                {this.state.paymentState == 0 && <><button onClick={(e) => {
                    this.setState({cardPaymentPrompt: false});
                    
                }} style={{background:"none",cursor:"pointer", outline:"none", border:"none"}}><svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      enableBackground="new 0 0 47.095 47.095"
      version="1.1"
      viewBox="0 0 47.095 47.095"
      xmlSpace="preserve"
      width={'20'}
    >
      <path d="M45.363 36.234l-13.158-13.16 12.21-12.21a5.906 5.906 0 000-8.358 5.908 5.908 0 00-8.356 0l-12.212 12.21-12.809-12.81a5.91 5.91 0 10-8.358 8.358l12.81 12.81L1.732 36.831a5.91 5.91 0 108.356 8.359l13.759-13.758 13.16 13.16a5.908 5.908 0 008.356 0 5.907 5.907 0 000-8.358z"></path>
    </svg></button>
                    
                    <Cards
          cvc={this.state.cvc}
          expiry={this.state.expiry.replace(/\//g,"")}
          focused={this.state.focus}
          name={this.state.name}
          number={this.state.number}
          placeholders={{name: "AD SOYAD", valid:""}}
        />
        
        <form ref={c => (this.form = c)} onSubmit={(e) => {
            e.preventDefault();
        }}>
        <div style={{marginBottom:10, marginTop:20}} className="form-group">
              <input
                type="text"
                name="name"
                className="bookingInput"
                placeholder="Kart üzerindeki isim"
                required
                autoComplete='cc-name'
                onChange={(e) => this.setState({name: e.target.value})}
                value={this.state.name}
              /></div>
              <div style={{justifyContent:"center", padding:0, alignItems:"center", display:"flex"}}>

                <div>
                <PaymentInputs onPayment={() => {
                    this.setState({paymentProcessing: true});

                    this.book({expiry: this.state.expiry.replace(/ /g, ""), owner: this.state.name, number: this.state.number.replace(/ /g, ""), cvc:this.state.cvc});
                }} onErrorChange={(e) => {
                    this.setState({cardErrorEmpty: e.error == undefined})
                }} onNumberChange={(e) => this.setState({number: e.target.value})} onExpiryChange={(e) => this.setState({expiry: e.target.value})} onCVCChange={(e) => this.setState({cvc: e.target.value})} cvc={this.state.cvc}
          expiry={this.state.expiry}
          focused={this.state.focus}
          name={this.state.name}
          number={this.state.number}
          paymentProcessing={this.state.paymentProcessing}
          />
          </div>
                {/* <CreditCardInput  customTextLabels={{
    invalidCardNumber: 'Kart numarası hatalı',
    expiryError: {
      invalidExpiryDate: 'Geçersiz son kullanma tarihi',
      monthOutOfRange: 'Geçersiz son kullanma tarih ayı',
      yearOutOfRange: 'Geçersiz son kullanma tarih yılı',
      dateOutOfRange: 'Geçersiz son kullanma tarihi'
    },
    invalidCvc: 'Hatalı CVC',
    expiryPlaceholder: 'AA/YY',
    cvcPlaceholder: 'CVC',
    cardNumberPlaceholder: "Kart Numarası"
  }} dangerTextClassName='cardInvalid' inputClassName='cardContainer' fieldClassName='cardField' containerClassName="cardRoot" cardNumberInputProps={{ value: this.state.number, onChange: (e) => {this.setState({number: e.target.value})} }}
  cardExpiryInputProps={{ value: this.state.expiry, onChange: (e) => {this.setState({expiry: e.target.value})} }}
  cardCVCInputProps={{ value: this.state.cvc, onChange: (e) => {this.setState({cvc: e.target.value})} }} /> */}
</div>
            <div className="form-actions">
            {/* <button onClick={() => {
                    
                }} disabled={!this.state.cardErrorEmpty} className='bookButton' style={{marginTop:30}}>Ödeme Yap</button> */}
            </div>
          </form></>}
          
            {this.state.paymentState == 1 && 
            <div className='secureIFrame'>
            <iframe allow='' onLoadedData={(a) => {
                console.log(a)
            }} src={this.state.UCD_URL} /></div>}

            {this.state.paymentState == 2 &&
            <div className='errorDiv'>
                
                <p className='loginTitle'>Ödeme başarısız</p>
              <p className='loginAlt'>Siparişinizin ödemesi alınırken bir hatayla karşılaşıldı:</p>
              <p className='loginAlt' style={{color:"crimson"}}>{this.state.paymentErrorMsg}</p>  

              <button onClick={() => {
                    this.setState({cardPaymentPrompt: false})
                }} className='bookButton' style={{marginTop:30,display:"flex",justifyContent:"center",alignItems:"center"}}>
                    
                    Tamam
                    
                    
            </button>
            </div>}
          
          </div>

          
            </div>
        </div>
    }

    calculatePricing() {
        
            

            //if(this.state.calculations == undefined ||this.state.vehicle == undefined) return 0;
            var p = 0;
            if(this.state.calculations != undefined && this.state.vehicle != undefined) {
                p += this.state.calculations[this.state.vehicle].price;

            }

            if(this.state.vehicle >= 2 && this.state.additionals[4] > 0) p += (this.state.vehicle == 2?.5:1)*helper_cost[this.state.vehicle]+(Math.max(this.state.additionals[4]-1,0)*helper_cost[this.state.vehicle]);
            return p;
        
    }
    book(paymentDetails) {
        
        
        API.fetchClient("order", {vehicle: this.state.vehicle,paymentDetails,waypoints: this.state.waypoints, date: this.state.date, installments: 0, additionals: this.state.additionals, price: this.calculatePricing(), paymentMethod: this.state.paymentMethod}).then((e) => {
            console.log(e);

            if(e.UCD_URL) {
                this.setState({paymentState: 1, UCD_URL: e.UCD_URL})
            }
        })
    }
}

function PaymentInputs(props) {
    const { meta, getCardNumberProps, getExpiryDateProps, getCVCProps } = usePaymentInputs({onError: (e) => () => props.onErrorChange(e),errorMessages: {
        dateOutOfRange: "Son kullanma tarihi hatalı",
        invalidCardNumber: "Kart numarası hatalı",
        emptyCardNumber: "Kart numarası boş bırakılamaz",
        emptyExpiryDate: "Son kullanma tarihi boş bırakılamaz", 
        emptyCVC: "CVC boş bırakılamaz", 
        invalidCVC: "CVC hatalı",
        invalidExpiryDate: "Son kullanma tarihi hatalı",
        monthOutOfRange: "Son kullanma tarihi hatalı",
        yearOutOfRange: "Son kullanma tarihi hatalı"
    }});
    
    
  
    return (
      <div>
        <input className='bookingInput' {...getCardNumberProps({ onChange: (e) => {props.onNumberChange(e)} })} placeholder='Kart numarası' value={props.number} />
        <div style={{display:"flex",marginTop:10,gap:10}}>
        <input className='bookingInput' {...getExpiryDateProps({ onChange: (e) => {props.onExpiryChange(e)}  })}  placeholder='AA/YY'  value={props.expiry} />
        <input className='bookingInput' {...getCVCProps({ onChange: (e) => {props.onCVCChange(e)}  })}  placeholder='CVC'  value={props.cvc} />
        </div>
        <span style={{visibility:meta.isTouched && meta.error?"visible":"hidden", color:"crimson"}}>{meta.error}</span>

        <button onClick={() => {
                    props.onPayment();
                }} disabled={meta.error || props.name.trim().length <= 0 || props.paymentProcessing} className='bookButton' style={{marginTop:30,display:"flex",justifyContent:"center",alignItems:"center"}}>
                    
                    {!props.paymentProcessing && "Ödeme Yap"}
                    {props.paymentProcessing && <div className="loading-spinner">
      
      </div>}
                    
            </button>
      </div>
    );
  }

const CheckboxService = (props) => {
    return <div className='bookingServiceCheckbox'>
        <div onClick={() => {
props.onChange(!props.value)
        }} className='container'><input onClick={() => {
            
        }} checked={props.value} type={'checkbox'}  /><span class="checkmark"></span></div><p>{props.title}</p>
        
    </div>
}

const Pricing = (props) => {
    return <div className='pricingDetailRoot' style={{display:"flex", flex:1,marginBottom:32, justifyContent:"space-between"}}>
        <p>{props.title}</p>
        <p>{props.value.toFixed(2)}₺</p>
    </div>
}

const PaymentMethod = (props) => {
    return <div onClick={() => props.onClick()} className={'paymentMethodRoot'+(props.selected?" bookSelected":"")}>
        <img src={props.src} />
        <p>{props.title}</p>
    </div>
}






class Waypoint extends React.Component {
    constructor(props) {
        super(props);
        this.state = {loading: false, autocomplete: []}
        
    }

    render() {
        return <div style={{maxWidth:530, marginTop:this.props.id==0?20:40}}>
        <div style={{display:"flex", flex:1,position:"relative",alignItems:"center"}}>
        <svg width="30" height="30" style={{marginRight:10}} viewBox="0 0 24 24"><g fill="none"><path fill="#3c9cd7" d="M12.585 21.336l-.585.512-.585-.512C6.499 17.034 4 13.286 4 10a8 8 0 1 1 16 0c0 3.286-2.499 7.034-7.415 11.336z"></path><path fill="#FFF" d="M12 7.444c1.655 0 3 1.348 3 3.002a3.002 3.002 0 0 1-3 2.998c-1.655 0-3-1.347-3-3a3.002 3.002 0 0 1 3-3z"></path></g></svg>
        
        <div style={{display:"flex",flex:1,alignItems:"center",position:"relative"}}><WaypointInput value={this.props.waypoint.Label} onChange={(v) => {
           this.props.waypoint.Label = v.target.value;
           this.setState({loading: true})
           
           const val = v.target.value;
           //this.props.onSelectedWaypoint(undefined);


           if(this.autocompleteQuery) clearTimeout(this.autocompleteQuery);
           
           if(val.trim() == "" || val.length <= 2) {

               this.autocompleteQuery = undefined;
               this.setState({autocomplete: [], loading: false})
               return;
           }
           this.autocompleteQuery = setTimeout(() => {
               var txt = val;
               API.fetchClient("autocomplete",{q: txt, session}).then((e) => {

                   console.log(e);
                  
                   if(this.props.waypoint.Label == txt) this.setState({autocomplete: e, loading: false});
               })

               
           }, 300);
       }} onFocus={() => {
        latestFocus = this.props.id;
        focused = true;
        this.forceUpdate();
       }} onBlur={() => {
        
        focused = false;
        this.setState({focused: false});
       }} placeholder={this.props.placeholder} />

{this.state.loading && <div style={{position:"absolute", right: 10,marginBottom:20}}>

<div className="spinner-container">
<div className="loading-spinner">
</div>
</div>
</div>}
       </div>
       
{latestFocus == this.props.id && focused && this.state.autocomplete.length > 0 && 
       <div className="autocompleteStart bookPage">
           
          
           {this.state.autocomplete.map((x, i) =>  <div onClick={() => {
               //this.props.onSelectedWaypoint(x);
               //this.setState({text: x.Label});
               this.state.autocomplete = [];
               this.props.onSelectedWaypoint(x);

            
            session = rnd(36);
           }} className='autocompleteKey' key={i}>
               <p>{x.Label}</p>
           </div>
       )}
           </div>}

           {this.props.canClose && <button onClick={(e) => {
                    
                    this.props.removeWaypoint();
                }} style={{background:"none",cursor:"pointer",marginLeft:15,marginRight:10, outline:"none", border:"none"}}><svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      enableBackground="new 0 0 47.095 47.095"
      version="1.1"
      viewBox="0 0 47.095 47.095"
      xmlSpace="preserve"
      width={'13'}
    >
      <path d="M45.363 36.234l-13.158-13.16 12.21-12.21a5.906 5.906 0 000-8.358 5.908 5.908 0 00-8.356 0l-12.212 12.21-12.809-12.81a5.91 5.91 0 10-8.358 8.358l12.81 12.81L1.732 36.831a5.91 5.91 0 108.356 8.359l13.759-13.758 13.16 13.16a5.908 5.908 0 008.356 0 5.907 5.907 0 000-8.358z"></path>
    </svg></button>}
        </div>

        <div style={{display:"flex", flex:1,position:"relative",alignItems:"center", marginTop:15, gap:15}}>
           <WaypointInput value={this.props.waypoint.building || ""} onChange={(e) => {this.props.waypoint.building = e.target.value; this.forceUpdate()}} placeholder={"Bina"} />
           <WaypointInput value={this.props.waypoint.door || ""} onChange={(e) => {this.props.waypoint.door = e.target.value; this.forceUpdate()}} placeholder={"Daire"} />
           <WaypointInput value={this.props.waypoint.floor || ""} onChange={(e) => {this.props.waypoint.floor = e.target.value; this.forceUpdate()}} placeholder={"Kat"} />

           
        </div>
        
        <input className='bookingInput bookingFadeable' value={this.props.waypoint.details || ""}  onChange={(e) => {
            this.props.waypoint.details = e.target.value;
            this.forceUpdate();
        }}  placeholder={"Adres detayları (Opsiyonel)"} type={'text'}  />
       


            
       </div>
    }
}

const WaypointInput = (props) => {
    return <input className='bookingInput' value={props.value}  onBlur={() => {
        setTimeout(() => {
            props.onBlur()
        }, 100);
        
    
    }} onChange={(e) => props.onChange(e)} onFocus={() => props.onFocus()}  placeholder={props.placeholder} type={'text'}  />
}

// class WaypointInput extends React.Component {


//     constructor() {
//         super();

//         this.state = {text: "",autocomplete: [], loading: false};
        
//     }

//     //768px
//     render() {
//         return  <input className='bookingInput' value={this.state.text}  onBlur={() => {
//             setTimeout(() => {
//                 this.props.onBlur()
//             }, 100);
            
        
//         }}  placeholder={this.props.placeholder} type={'text'}  />

            
        
        
       
        
        
    
//     }
// }